module.exports = __webpack_public_path__ + "img/tireExampleOutlined.4a922cf2.svg";